import { EventRegistry } from '../../../../../domain/event/event.registry';
import { FieldEvent } from './field.event';
export class FieldPutEvent extends FieldEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `field/${payload.id}`,
            type: FieldPutEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
FieldPutEvent.type = 'com.treeplotter.api.field.put.v1';
EventRegistry.register(FieldPutEvent.type, FieldPutEvent);
//# sourceMappingURL=field-put.event.js.map